import React from "react";
import "../HomeAbout.css";
import { NavLink } from "react-router-dom";

import {
    FiArrowRight,
    FiCheckCircle,
    FiShoppingCart,
    FiUsers,
    FiShoppingBag,
    FiGrid,
    FiBookOpen,
    FiSettings,
    FiShield,
    FiClock,
    FiDatabase,
    FiHeadphones,
} from "react-icons/fi";

const HomeAbout = () => {
    return (
        <section className="home-about">

            <div className="container">

                {/* Heading */}

                <div className="about-heading">

                    <span className="about-badge">
                        About Kishancart Digital
                    </span>

                    <h2>
                        Empowering Businesses with
                        <span> Innovative Digital Solutions</span>
                    </h2>

                    <p>
                        Kishancart Digital (OPC) Private Limited is a technology-driven
                        company committed to helping startups, retailers, and enterprises
                        build scalable digital solutions. We develop modern e-commerce
                        platforms, business websites, mobile applications, and custom
                        software that enable businesses to grow faster and operate more
                        efficiently in today's digital world.
                        At Kishancart Digital, we believe that every business deserves innovative technology that fuels long-term success. Our mission is to build future-ready digital solutions that help businesses adapt, compete, and grow confidently in today's rapidly evolving digital economy. We focus on quality, transparency, innovation, and long-term partnerships, ensuring that every project we deliver creates real value for our clients.
                    </p>

                </div>

                {/* Content */}

                <div className="about-content">

                    {/* Left Card */}

                    <div className="about-card">

                        <h3>What We Do</h3>

                        <p>
                            We deliver end-to-end digital solutions designed to strengthen
                            your online presence, streamline business operations, and create
                            exceptional customer experiences through innovative technology.
                        </p>

                        <div className="about-list">

                            <div className="about-item">
                                <FiShoppingCart />
                                <span>Custom E-Commerce Development</span>
                            </div>

                            <div className="about-item">
                                <FiUsers />
                                <span>Vendor Management</span>
                            </div>

                            <div className="about-item">
                                <FiShoppingBag />
                                <span>Retail Management</span>
                            </div>

                            <div className="about-item">
                                <FiGrid />
                                <span>Marketplace Management</span>
                            </div>

                            <div className="about-item">
                                <FiBookOpen />
                                <span>Digital Product Catalog</span>
                            </div>

                            <div className="about-item">
                                <FiShoppingCart />
                                <span>Order & Inventory Management</span>
                            </div>

                            <div className="about-item">
                                <FiCheckCircle />
                                <span>Business Growth Solutions</span>
                            </div>

                        </div>

                    </div>

                    {/* Right Card */}

                    <div className="about-card">

                        <h3>Why Choose Us</h3>

                        <p>
                            Our approach combines creativity, innovation, and the latest
                            technologies to deliver secure, scalable, and future-ready
                            solutions tailored to your business goals.
                        </p>

                        <div className="about-list">

                            <div className="about-item">
                                <FiCheckCircle />
                                <span>Experienced Development Team</span>
                            </div>

                            <div className="about-item">
                                <FiSettings />
                                <span>Customized Business Solutions</span>
                            </div>

                            <div className="about-item">
                                <FiShield />
                                <span>Secure & Scalable Architecture</span>
                            </div>

                            <div className="about-item">
                                <FiArrowRight />
                                <span>Long-Term Technical Support</span>
                            </div>

                            <div className="about-item">
                                <FiClock />
                                <span>On-Time Project Delivery</span>
                            </div>

                            <div className="about-item">
                                <FiDatabase />
                                <span>Cloud-Based Business Solutions</span>
                            </div>

                            <div className="about-item">
                                <FiHeadphones />
                                <span>Dedicated Customer Assistance</span>
                            </div>

                        </div>

                    </div>

                </div>

                <div>
                    <img
                        src={require("../../assets/Main-Banner.png")}
                        alt="Industries Illustration"
                        className="industries-illustration" style={{ width: "100%", objectFit: "cover", borderRadius: "10px", marginTop: "40px" }}
                    />
                </div>

                {/* Button */}

                <div className="about-btn-wrap">

                    <a 
                        href="/about"
                        className="about-btn"
                    >
                        Read More About Us
                        <FiArrowRight />
                    </a>

                </div>

            </div>

        </section>
    );
};

export default HomeAbout;